import { render, staticRenderFns } from "./ShowIdentifier.vue?vue&type=template&id=0406585b&scoped=true"
import script from "./ShowIdentifier.vue?vue&type=script&lang=js"
export * from "./ShowIdentifier.vue?vue&type=script&lang=js"
import style0 from "./ShowIdentifier.vue?vue&type=style&index=0&id=0406585b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406585b",
  null
  
)

export default component.exports